import React, { useContext, useEffect } from 'react'
import { UGE_GA_PREFIX } from '../../constants'
import { CreationToolsContext } from '../../manager'
import CreationToolOutputType from '../../types/output-type'
import SourceEditorModal from '../source-editor/modal'
import { SourceEditorEdits } from '../source-editor/types'
import { CreationToolUploadContext } from './manager'

const GA_CATEGORY = 'Upload'

const CreationUploadEditor = () => {
    const { trackEvent } = useContext(CreationToolsContext)
    const { editing, setEditing, updateUploadSource } = useContext(CreationToolUploadContext)

    const fireGAEvent = (action: string, value?: string) => {
        if (!editing) return

        const gaLabel = CreationToolOutputType.title(editing.source.outputType)
        trackEvent(GA_CATEGORY, `${UGE_GA_PREFIX}${action}`, gaLabel, value)
    }

    useEffect(() => {
        if (!editing) return

        fireGAEvent('Edit')
    }, [editing, fireGAEvent])

    if (!editing) {
        return null
    }

    const {
        source: { source, outputType, edits },
        defaultEditor,
    } = editing

    const onCancel = () => {
        setEditing(undefined)
    }

    const onDone = async (sourceEdits?: SourceEditorEdits) => {
        if (sourceEdits) {
            // layers events
            const layers = sourceEdits?.captions?.filter(c => c.start || c.end) || []
            if (layers?.length > 0 && !edits?.captions) {
                fireGAEvent('Layers', `${layers.length}`)
            }

            // caption events
            if (sourceEdits?.captions && !edits?.captions) {
                const totalCaptions = sourceEdits.captions.length
                fireGAEvent('Add Caption', `${totalCaptions}`)
            }

            // crop events
            if (sourceEdits?.crop && !edits?.crop) {
                const aspectRatio = (sourceEdits.crop.width / sourceEdits.crop.height).toFixed(2)
                fireGAEvent('Crop', aspectRatio)
            }

            // trim events
            if (sourceEdits?.trim && !edits?.trim) {
                const duration = Math.round(sourceEdits.trim.end - sourceEdits.trim.start)
                fireGAEvent('Trim', `${duration}`)
            }

            // update source edits
            updateUploadSource({
                ...editing.source,
                edits: sourceEdits,
            })
        }

        setEditing(undefined)
    }

    return (
        <SourceEditorModal
            {...{
                source,
                edits,
                defaultEditor,
                outputType,
                onCancel,
                onDone,
            }}
        />
    )
}

export default CreationUploadEditor
